import { IActivityCommunity, ActivityCommunityEntity } from "./types";

/**
 * ActivityCommunity entity schema convert to model
 */
export function mapActivityCommunityFromEntity(entity: ActivityCommunityEntity): IActivityCommunity {
    return {
        id: entity.id,
        key: entity.key,
        title: entity.title,
        description: entity.description,
        content: entity.content,
        order: entity.order || 0,
        profileImageVertical: entity.profileImageVertical,
        profileImageHorizontal: entity.profileImageHorizontal,
        isShowList: entity.isShowList || false,
        rules: entity.rules || [],
        language: entity.language,
        relationId: entity.languageRelationId,
        createdBy: entity.createdBy,
        updatedBy: entity.modifiedBy,
        createdAt: entity.createdOn || entity.CreatedOn,
        updatedAt: entity.modifiedOn || entity.ModifiedOn
    }
}

/**
 * ActivityCommunity model schema convert to entity
 */
export function mapActivityCommunityFromModel(model: IActivityCommunity): ActivityCommunityEntity {
    return {
        id: model.id,
        key: model.key,
        title: model.title,
        description: model.description,
        order: model.order || 0,
        rules: model.rules || [],
        content: model.content,
        isShowList: model.isShowList || false,
        profileImageVertical: model.profileImageVertical,
        profileImageHorizontal: model.profileImageHorizontal,
        language: model.language,
        languageRelationId: model.relationId || undefined
    }
}

